import React from 'react';
import { Paper, Typography, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ConditionsGenerales = () => {
    const theme = useTheme();
    const data = {
        individual: {
            title: "Assuré et/ou Salarié",
            services: [
                "Consulter ses prestations",
                "Documents"
            ]
        },
        enterprise: {
            title: "Entreprise",
            services: [
                "Consultation des prestations versées",
                "Consultation de l'historique des prestations versées",
                "Déclaration de sinistres",
                "Consultation de l'historique des sinistres",
                "Administration des comptes du site"
            ]
        }
    };
    return (
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Paper elevation={3} style={{ padding: '20px',
                Color: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
            }}>
                <Typography variant="h4" gutterBottom>
                    CONDITIONS GÉNÉRALES D’UTILISATION
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 1 - DÉFINITIONS
                </Typography>
                <Typography variant="body1" paragraph>
                    « Uniprévoyance » : désigne Uniprévoyance, Siret : 318 990 736 0004, dont le siège est situé 38-42
                    Rue Cuvier, CS 80 002, 93102 Montreuil Cedex. Institution Paritaire de Prévoyance régie par le Code
                    de la Sécurité Sociale, Uniprévoyance relève de l’Autorité de Contrôle Prudentiel et de Résolution
                    (ACPR) 61 rue Taitbout, 75436 Paris Cedex 9.
                </Typography>
                <Typography variant="body1" paragraph>
                    « Codes d’Accès » : désigne l’identifiant et le mot de passe de l’Utilisateur.
                </Typography>
                <Typography variant="body1" paragraph>
                    « Conditions d’Utilisation » : désigne les présentes conditions générales d’utilisation.
                </Typography>
                <Typography variant="body1" paragraph>
                    « Données Utilisateur » : désigne les Codes d’Accès et l’ensemble des informations fournies
                    par l’Utilisateur lors de son inscription au Service puis lors de l’utilisation de celui-ci.
                </Typography>
                <Typography variant="body1" paragraph>
                    « Service » : défini à l’article 5 des Conditions d’Utilisation.
                </Typography>
                <Typography variant="body1" paragraph>
                    « Site » : désigne le site Internet accessible à l’adresse suivante :
                </Typography>
                <Typography variant="body1" paragraph>
                    « Utilisateur » : désigne tout client d’Uniprévoyance, qu’il soit une société souscriptrice, un salarié
                    ou un particulier.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 2 - OBJET
                </Typography>
                <Typography variant="body1" paragraph>
                    L’objet des présentes Conditions d’Utilisation est de définir les modalités de fonctionnement et d’accès
                    au Service par les Utilisateurs.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 3 - INSCRIPTION ET ACCÈS AU SERVICE
                </Typography>
                <Typography variant="body1" paragraph>
                    Le Service ne peut être utilisé sans inscription préalable. Cette démarche est réalisable directement
                    via « L’ESPACE CLIENT » disponible sur le Site. Pour créer un compte sur le Site, l’Utilisateur
                    devra compléter les champs obligatoires des formulaires d’inscription. L’Utilisateur garantit qu’il a
                    toute capacité à utiliser le Service et que les données qu’il communique sont exactes, conformes à la
                    réalité et régulièrement mises à jour.
                </Typography>

                <Typography variant="body1" paragraph>
                    Au terme du processus d’inscription, l’Utilisateur reconnaît avoir pris connaissance et accepté
                    l’ensemble des Conditions d’Utilisation.
                </Typography>
                <Typography variant="body1" paragraph>
                    Tous les frais d’accès au réseau Internet et ceux liés à l’utilisation du Site sont à la charge de l’Utilisateur
                    (frais de télécommunications, équipements informatiques, logiciels, ...).
                </Typography>
                <Typography variant="body1" paragraph>
                    L’accès au Service est sécurisé par un système de chiffrement des données qui nécessite l’utilisation
                    d’un système d’exploitation et un navigateur adapté.
                </Typography>
                <Typography variant="body1" paragraph>
                    En cas de non-respect d’une ou plusieurs dispositions des présentes Conditions d’Utilisation, les
                    Codes d’Accès de l’Utilisateur pourront être unilatéralement, de plein droit et sans préavis,
                    temporairement suspendus ou définitivement bloqués.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur reconnaît et accepte que ses Codes d’Accès pourront être suspendus ou bloqués
                    automatiquement à compter de l’ext inction ou de la résiliation pour quelle que raison que ce soit de son contrat d’assurance.
                </Typography>
                <Typography variant="body1" paragraph>
                    En cas d’Utilisateur multi-équipé, ses Codes d’Accès pourront être suspendus ou bloqués lors de
                    l’extinction ou de la résiliation pour quelle que raison que ce soit de l’ensemble de ses contrats
                    d’assurances.
                </Typography>
                <Typography variant="h4" gutterBottom>
                    CONDITIONS GÉNÉRALES D’UTILISATION
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 4 - GESTION ET UTILISATION DES CODES D’ACCÈS
                </Typography>
                <Typography variant="body1" paragraph>
                    Par souci de sécurité et de confidentialité, une fois l’inscription terminée, un e-mail est envoyé à
                    l’Utilisateur comprenant notamment :<br />
                    • un lien d’activation de compte.
                </Typography>
                <Typography variant="body1" paragraph>
                    Dans un souci de stricte confidentialité, l’Utilisateur indiquera son mot de passe lors de
                    l’activation de son compte via ledit lien d’activation. Chaque identifiant est unique, propre à chaque
                    Utilisateur et strictement confidentiel. La combinaison de l’identifiant et du mot de passe, qui a valeur
                    de signature électronique au sens de l’article 1367 du Code Civil, permet à chaque Utilisateur de
                    s’identifier auprès du Site. À ce titre, l’Utilisateur s’engage à garder le caractère secret des éléments
                    d’identification étant entendu qu’Uniprévoyance ne pourra être tenue responsable de toute perte ou tout
                    dommage survenant en cas de manquement à cette obligation, toute utilisation des Codes d’Accès étant faite
                    sous l’entière responsabilité de l’Utilisateur.
                </Typography>
                <Typography variant="body1" paragraph>
                    En cas de perte par l’Utilisateur de son identifiant, Uniprévoyance le lui renverra par e-mail, après que ce
                    premier ait renseigné un certain nombre d’informations le concernant.
                </Typography>
                <Typography variant="body1" paragraph>
                    En cas de perte par l’Utilisateur de son mot de passe, Uniprévoyance le lui réinitialisera par e-mail,
                    après que ce premier ait renseigné un certain nombre d’informations le concernant.
                </Typography>
                <Typography variant="body1" paragraph>
                    En cas d’utilisation frauduleuse de l’un des Codes d’Accès, l’Utilisateur s’engage à le notifier dans les
                    meilleurs délais à Uniprévoyance. Les Codes d’Accès usurpés seront supprimés par Uniprévoyance.
                    L’Utilisateur devra procéder à sa réinscription aux Services.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur reconnaît que les demandes liées à l’utilisation du Service effectuées électroniquement ont
                    la même valeur que celles effectuées par demande écrite.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 5 – SERVICE
                </Typography>
                <Typography variant="body1" paragraph>
                    UNIPREVOYANCE met à disposition de l’Utilisateur, sur le Site, à titre gratuit, un service en ligne
                    dont le contenu diffère en fonction de la nature de son contrat d’assurance.
                </Typography>
                <Typography variant="body1" paragraph>
                    UNIPREVOYANCE précise que le contenu du Service n’est pas exhaustif et se réserve le droit de
                    modifier librement et à tout moment ledit contenu, c'est-à-dire supprimer, bloquer ou y ajouter des
                    fonctionnalités.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 6 - RESPONSABILITÉ
                </Typography>
                <Typography variant="body1" paragraph>
                    L’ensemble des informations et/ou résultats de simulation délivrés dans le Site sont fournis à titre
                    indicatif et n’ont pas de valeur contractuelle. Malgré le soin apporté dans le choix desdites
                    informations et/ou résultats et leur mise à jour, il est néanmoins possible que ceux-ci contiennent
                    des erreurs, imprécisions ou omissions. Ainsi l’exactitude et l’exhaustivité des informations et/ou résultats
                    de simulation contenus sur le Site ne sont pas garantis. En conséquence, l'Utilisateur reconnaît utiliser
                    ces informations et résultats sous sa responsabilité exclusive et avec précaution. L’ensemble de ces
                    informations et résultats de simulation ne sont donnés que pour une durée limitée à leur validité.
                </Typography>
                <Typography variant="body1" paragraph>
                    La responsabilité d’Uniprévoyance, limitée aux dommages directs, ne pourra être recherchée que s'il
                    est établi qu'elle a commis une faute lourde et ne saurait en tout état de cause être engagée
                    en raison des arrêts pour maintenance, ou de faits indépendants de sa volonté (notamment défaillance du
                    réseau ou du fournisseur d'accès à Internet).
                </Typography>
                <Typography variant="h4" gutterBottom>
                    CONDITIONS GÉNÉRALES D’UTILISATION
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 6 - RESPONSABILITÉ
                </Typography>
                <Typography variant="body1" paragraph>
                    La responsabilité d’Uniprévoyance ne saurait donc être engagée :
                </Typography>
                <Typography variant="body1" paragraph>
                    • en cas de force majeure au sens du Code civil;<br />
                    • de fait indépendant de sa volonté notamment en cas d’interruption du Service résultant d’une
                    défaillance du réseau ou du fournisseur d’accès à Internet ;<br />
                    • des arrêts notamment pour maintenance, pour perturbations causées par des travaux,
                    notamment d’entretien, de renforcement, de réaménagement ou d’extension des installations
                    de son réseau ;<br />
                    • d’une manière générale pour toute autre cause relative au réseau Internet indépendante de la
                    sphère d’action directe d’Uniprévoyance ;<br />
                    • du fait d’une utilisation du Service par l’Utilisateur non conforme aux Conditions d’Utilisation.
                </Typography>
                <Typography variant="body1" paragraph>
                    Dans une des hypothèses mentionnées ci-dessus, aucune indemnité ne saurait être octroyée au titre
                    d’une indisponibilité du Site, qu’elle soit temporaire ou définitive.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur est responsable de son utilisation du Service. Il s’engage à indemniser, préserver et tenir
                    Uniprévoyance indemne de tous dommages et intérêts et / ou pertes, y compris les frais de
                    défense y afférents, résultant du manquement partiel ou total, volontaire ou non, de l’Utilisateur
                    à l’une quelconque des obligations et engagements lui incombant au titre des Conditions d’Utilisation.
                </Typography>
                <Typography variant="body1" paragraph>
                    Dans l’hypothèse où le Site comporterait des informations mises à disposition par des sites externes
                    ou des liens vers d’autres sites qui n’ont pas été développés par Uniprévoyance, il appartiendra à
                    l’Utilisateur d’utiliser ces informations avec discernement et esprit critique, Uniprévoyance n’étant
                    pas responsable de leur contenu.
                </Typography>
                <Typography variant="body1" paragraph>
                    Tout Utilisateur doit se protéger des virus qui pourraient lui être transmis lors de son utilisation du
                    Service ou lors de sa visite des sites accessibles à partir du Site par des liens hypertextes. Par
                    conséquent, Uniprévoyance ne saurait être tenue pour responsable en cas de dommages causés par
                    un virus ou une fraude informatique.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 7 - CONVENTION DE PREUVE
                </Typography>
                <Typography variant="body1" paragraph>
                    Les registres informatisés du Site conservés dans le respect des règles de l’art en matière de sécurité,
                    seront considérés comme preuves des communications de courriers électroniques, envois de
                    formulaires et tout autre échange d’informations entre l’Utilisateur et le Site. Il est convenu qu’en
                    cas de divergence entre les registres informatisés du Site et les documents au format papier ou
                    électronique dont dispose l’Utilisateur, les registres papier feront foi.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 8 - PROPRIÉTÉ INTELLECTUELLE
                </Typography>
                <Typography variant="body1" paragraph>
                    Uniprévoyance avise les Utilisateurs que la structure générale, ainsi que les textes, images
                    animées ou non, sons, logos, savoir-faire ainsi que tout autre élément composant le Site :
                </Typography>
                <Typography variant="body1" paragraph>
                    • sont protégés par la législation française sur les droits d’auteur,<br />
                    • sont protégés par la législation sur les marques.
                </Typography>
                <Typography variant="body1" paragraph>
                    À ce titre, toute reproduction, représentation, utilisation, adaptation, modification, incorporation,
                    traduction, commercialisation partielles ou intégrales, de quelque manière, sous quelque forme, par
                    quelque procédé et sur quelque support que ce soit (papier, numérique…) de la structure générale,
                    ainsi que des textes, images animées ou non, sons, savoir-faire ainsi que tout autre élément
                    composant le Site, sont interdites, sans l’autorisation écrite préalable d’Uniprévoyance, hormis les
                    exceptions légalement admises par le Code de la propriété intellectuelle, sous peine de contrefaçon,
                    sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
                </Typography>

                <Typography variant="body1" paragraph>
                    Il en est de même des bases de données figurant, le cas échéant, sur le Site, qui sont protégées par
                    les dispositions de la loi du 1er juillet 1998 portant transposition, dans le Code de la propriété
                    intellectuelle, de la directive européenne 96/9/CE du 11 mars 1996 relative à la protection juridique des
                    bases de données.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les marques et les logos qui figurent sur le Site sont des marques déposées. Toute reproduction totale
                    ou partielle de ces marques ou logos, effectuée à partir des éléments du Site est donc prohibée, au
                    sens de l'article L.713-2 du Code de la propriété intellectuelle.
                </Typography>
                <Typography variant="body1" paragraph>
                    Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les
                    représentations iconographiques et photographiques.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur est propriétaire et seul responsable des Données Utilisateurs. Il s’engage à ce qu’elles ne
                    soient pas de nature à porter atteinte aux intérêts légitimes de tout tiers et garantit Uniprévoyance
                    contre toute réclamation de tiers à cet égard.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 9 – DONNÉES PERSONNELLES
                </Typography>
                <Typography variant="body1" paragraph>
                    Les données personnelles collectées sur ce Site sont exclusivement destinées à Uniprévoyance.
                    L’utilisation de ces informations est strictement limitée à des fins de gestion administrative.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les données personnelles collectées au titre de la gestion d’un contrat d’assurance peuvent être
                    utilisées pour des traitements de lutte contre la fraude afin de prévenir, de détecter ou de gérer les
                    opérations, actes, ou omissions à risque, et pouvant conduire à l’inscription sur une liste de personnes
                    présentant un risque de fraude.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les Utilisateurs sont informés qu’ils disposent d’un droit d’accès, de modification, de suppression et
                    d’opposition sur les données qui les concernent, conformément à la loi Informatique et Libertés du 6
                    janvier 1978 modifiée.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur peut exercer ces droits en s’adressant au service DPO d'Uniprevoyance FRANCE
                    à l’adresse dpo@uniprevoyance.fr.
                </Typography>
                <Typography variant="body1" paragraph>
                    Conformément au décret n°2007-451 du 25 mars 2007 le traitement de la demande peut être, selon sa
                    nature, subordonné à la production préalable de la copie d’une pièce d’identité en cours de validité.
                </Typography>

                <Typography variant="h6" paragraph>
                    ART. 10 - DROIT APPLICABLE – RÈGLEMENT DES LITIGES
                </Typography>
                <Typography variant="body1" paragraph>
                    Les Conditions d’Utilisation sont régies et interprétées conformément au droit français. Tout litige en
                    relation avec les Conditions d’Utilisation, qu’il soit lié à sa validité, à son interprétation ou à son
                    exécution sera soumis à la compétence exclusive des tribunaux français.
                </Typography>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{data.individual.title}</TableCell>
                                <TableCell>{data.enterprise.title}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <ul>
                                        {data.individual.services.map((service, index) => (
                                            <li key={index}>{service}</li>
                                        ))}
                                    </ul>
                                </TableCell>
                                <TableCell>
                                    <ul>
                                        {data.enterprise.services.map((service, index) => (
                                            <li key={index}>{service}</li>
                                        ))}
                                    </ul>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                        <Box
                            sx={{
                                padding: 2,
                                borderRadius: '8px',
                                maxWidth: 400,
                                margin: '0 auto'  // Centers the Box within the Paper
                            }}
                        >
                            <Typography variant="h6" gutterBottom align="center">
                                Contact Information
                            </Typography>
                            <Typography variant="body2" align="center">
                                38-42 Rue Cuvier, CS 80 002, 93102 Montreuil Cedex
                            </Typography>
                            <Typography variant="body2" align="center">
                                Tél: <Link href="tel:0158844100">01 58 84 41 00</Link>
                            </Typography>
                            <Typography variant="body2" align="center">
                                Website: <Link href="http://www.uniprevoyance.fr" target="_blank" rel="noopener">www.uniprevoyance.fr</Link>
                            </Typography>
                            <Typography variant="body2" sx={{ marginTop: 1 }} align="center">
                                Institution de Prévoyance régie par le code de la Sécurité Sociale
                            </Typography>
                        </Box>
            </Paper>
        </Container>
    );
};

export default ConditionsGenerales;
